var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BookerBase, padding } from '@buseditor/components';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormHelperText, IconButton, Tab, Tabs, Tooltip, Typography, useTheme } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import dayjs from 'dayjs';
import _, { throttle } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { _T } from '../../../include/appI18n';
import { api } from '../../../include/network/network';
import Select from '../../../include/react-components/Select';
import { formatMoney } from '../../../include/utils';
import AsyncSpinner from '../../TourSearch/components/TourDescription/AsyncSpinner';
import { getExtraKey } from '../../TourSearch/store/utils';
import { BookerViewControls } from './BookerViewControls';
import { renderSeatPricePopup } from './SeatPricePopup';
const normalizeScheme = (rawScheme) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    if (!rawScheme)
        return undefined;
    const schemeTypeValue = (_b = (_a = rawScheme.schemeType) !== null && _a !== void 0 ? _a : rawScheme.SchemeType) !== null && _b !== void 0 ? _b : rawScheme.scheme_type;
    const normalizedType = typeof schemeTypeValue === 'string'
        ? schemeTypeValue.toLowerCase() === 'aircraft'
            ? 'Aircraft'
            : schemeTypeValue.toLowerCase() === 'bus'
                ? 'Bus'
                : undefined
        : schemeTypeValue === 1
            ? 'Aircraft'
            : schemeTypeValue === 0
                ? 'Bus'
                : undefined;
    const rawData = (_e = (_d = (_c = rawScheme.data) !== null && _c !== void 0 ? _c : rawScheme.Data) !== null && _d !== void 0 ? _d : rawScheme.schemeData) !== null && _e !== void 0 ? _e : rawScheme.SchemeData;
    const rawBus = (_f = rawData === null || rawData === void 0 ? void 0 : rawData.bus) !== null && _f !== void 0 ? _f : rawData === null || rawData === void 0 ? void 0 : rawData.Bus;
    const rawSeats = (_h = (_g = rawData === null || rawData === void 0 ? void 0 : rawData.seats) !== null && _g !== void 0 ? _g : rawData === null || rawData === void 0 ? void 0 : rawData.Seats) !== null && _h !== void 0 ? _h : [];
    const rawElements = (_k = (_j = rawData === null || rawData === void 0 ? void 0 : rawData.elements) !== null && _j !== void 0 ? _j : rawData === null || rawData === void 0 ? void 0 : rawData.Elements) !== null && _k !== void 0 ? _k : [];
    const rawConditions = (_o = (_m = (_l = rawData === null || rawData === void 0 ? void 0 : rawData.conditions) !== null && _l !== void 0 ? _l : rawData === null || rawData === void 0 ? void 0 : rawData.Conditions) !== null && _m !== void 0 ? _m : rawData === null || rawData === void 0 ? void 0 : rawData.placeConditions) !== null && _o !== void 0 ? _o : rawData === null || rawData === void 0 ? void 0 : rawData.PlaceConditions;
    const normalizedSeats = rawSeats.map((seat) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, seat), { sectionId: (_a = seat === null || seat === void 0 ? void 0 : seat.sectionId) !== null && _a !== void 0 ? _a : seat === null || seat === void 0 ? void 0 : seat.SectionId, flightClassGroupId: (_b = seat === null || seat === void 0 ? void 0 : seat.flightClassGroupId) !== null && _b !== void 0 ? _b : seat === null || seat === void 0 ? void 0 : seat.FlightClassGroupId }));
    });
    const rawSections = (_p = rawBus === null || rawBus === void 0 ? void 0 : rawBus.sections) !== null && _p !== void 0 ? _p : rawBus === null || rawBus === void 0 ? void 0 : rawBus.Sections;
    const inferredType = normalizedType
        ? normalizedType
        : (Array.isArray(rawSections) && rawSections.length > 0)
            || normalizedSeats.some((s) => !!(s === null || s === void 0 ? void 0 : s.sectionId) || (s === null || s === void 0 ? void 0 : s.flightClassGroupId) !== undefined)
            ? 'Aircraft'
            : 'Bus';
    const seats = inferredType === 'Aircraft' && !normalizedSeats.some((s) => !!(s === null || s === void 0 ? void 0 : s.sectionId) || (s === null || s === void 0 ? void 0 : s.flightClassGroupId) !== undefined)
        ? normalizedSeats.map((seat) => { var _a; return (Object.assign(Object.assign({}, seat), { sectionId: (_a = seat === null || seat === void 0 ? void 0 : seat.sectionId) !== null && _a !== void 0 ? _a : 'section-1' })); })
        : normalizedSeats;
    const normalizedBus = rawBus ? Object.assign(Object.assign({}, rawBus), { width: (_q = rawBus === null || rawBus === void 0 ? void 0 : rawBus.width) !== null && _q !== void 0 ? _q : rawBus === null || rawBus === void 0 ? void 0 : rawBus.Width, height: (_r = rawBus === null || rawBus === void 0 ? void 0 : rawBus.height) !== null && _r !== void 0 ? _r : rawBus === null || rawBus === void 0 ? void 0 : rawBus.Height, seatWidth: (_s = rawBus === null || rawBus === void 0 ? void 0 : rawBus.seatWidth) !== null && _s !== void 0 ? _s : rawBus === null || rawBus === void 0 ? void 0 : rawBus.SeatWidth, seatHeight: (_t = rawBus === null || rawBus === void 0 ? void 0 : rawBus.seatHeight) !== null && _t !== void 0 ? _t : rawBus === null || rawBus === void 0 ? void 0 : rawBus.SeatHeight, seatFrontSpacing: (_u = rawBus === null || rawBus === void 0 ? void 0 : rawBus.seatFrontSpacing) !== null && _u !== void 0 ? _u : rawBus === null || rawBus === void 0 ? void 0 : rawBus.SeatFrontSpacing, seatSideSpacing: (_v = rawBus === null || rawBus === void 0 ? void 0 : rawBus.seatSideSpacing) !== null && _v !== void 0 ? _v : rawBus === null || rawBus === void 0 ? void 0 : rawBus.SeatSideSpacing, gridSize: (_w = rawBus === null || rawBus === void 0 ? void 0 : rawBus.gridSize) !== null && _w !== void 0 ? _w : rawBus === null || rawBus === void 0 ? void 0 : rawBus.GridSize, layers: (_x = rawBus === null || rawBus === void 0 ? void 0 : rawBus.layers) !== null && _x !== void 0 ? _x : rawBus === null || rawBus === void 0 ? void 0 : rawBus.Layers }) : rawBus;
    return Object.assign(Object.assign({}, rawScheme), { schemeType: inferredType, data: rawData ? Object.assign(Object.assign({}, rawData), { bus: (_y = normalizedBus !== null && normalizedBus !== void 0 ? normalizedBus : rawData === null || rawData === void 0 ? void 0 : rawData.bus) !== null && _y !== void 0 ? _y : rawData === null || rawData === void 0 ? void 0 : rawData.Bus, seats, elements: rawElements, conditions: rawConditions }) : rawScheme.data, created: dayjs((_z = rawScheme.created) !== null && _z !== void 0 ? _z : rawScheme.Created), updated: rawScheme.updated || rawScheme.Updated ? dayjs((_0 = rawScheme.updated) !== null && _0 !== void 0 ? _0 : rawScheme.Updated) : undefined });
};
const seatMatchesFlightClass = (seat, flightClassId) => {
    if (!flightClassId)
        return true;
    if (seat.flightClassGroupId === undefined || seat.flightClassGroupId === null)
        return false;
    return seat.flightClassGroupId === flightClassId;
};
const resolveTourFlightSchemeId = (flight) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!flight)
        return 0;
    const schemeFromCalc = (_f = (_c = (_b = (_a = flight.calcFlights) === null || _a === void 0 ? void 0 : _a.find(f => { var _a; return ((_a = f.schemeId) !== null && _a !== void 0 ? _a : 0) > 0; })) === null || _b === void 0 ? void 0 : _b.schemeId) !== null && _c !== void 0 ? _c : (_e = (_d = flight.calcFlights) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.schemeId) !== null && _f !== void 0 ? _f : 0;
    return (_h = (_g = flight.schemeId) !== null && _g !== void 0 ? _g : schemeFromCalc) !== null && _h !== void 0 ? _h : 0;
};
const isPrecheckFlightPlaceId = (placeId) => {
    return !!placeId && placeId.startsWith('_precheck_');
};
const getServicePersonCount = (service) => {
    var _a, _b, _c, _d;
    const accommodation = service.accommodation;
    const count = ((_a = accommodation === null || accommodation === void 0 ? void 0 : accommodation.adults) !== null && _a !== void 0 ? _a : 0) + ((_b = accommodation === null || accommodation === void 0 ? void 0 : accommodation.childs) !== null && _b !== void 0 ? _b : 0);
    return count > 0 ? count : ((_d = (_c = service.tourists) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0);
};
const getServiceChildAges = (service) => {
    var _a;
    const accommodation = service.accommodation;
    if ((_a = accommodation === null || accommodation === void 0 ? void 0 : accommodation.childAccommodations) === null || _a === void 0 ? void 0 : _a.length)
        return accommodation.childAccommodations.map(x => x.age);
    return [];
};
export function FlightSchemeModal({ booking, onServiceChange, onMakeBooking, allowSkipPlaceSelection, onSkipPlaceSelection, confirmButtonText }) {
    var _a, _b, _c;
    const theme = useTheme();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedTouristIndex, setSelectedTouristIndex] = useState(undefined);
    const [segmentSelections, setSegmentSelections] = useState({});
    const [segmentSchemes, setSegmentSchemes] = useState({});
    const [segmentUnavailable, setSegmentUnavailable] = useState({});
    const [segmentScale, setSegmentScale] = useState({});
    const [segmentRotation, setSegmentRotation] = useState({});
    const loadingSegmentKeysRef = useRef(new Set());
    const bookerContainerRef = useRef(null);
    const [size, setSize] = useState({ width: 1000, height: 1000 });
    const segments = useMemo(() => {
        const items = [];
        const bookingFlights = booking.services.filter(s => s.type === 'BookingFlightService');
        bookingFlights.forEach(svc => {
            var _a, _b, _c, _d, _e;
            const schemeId = (_a = svc.schemeId) !== null && _a !== void 0 ? _a : 0;
            if (!svc.scheme && !schemeId)
                return;
            const fromName = (_b = svc.cityFrom) === null || _b === void 0 ? void 0 : _b.name;
            const toName = (_c = svc.cityTo) === null || _c === void 0 ? void 0 : _c.name;
            const baseName = fromName && toName ? `${fromName} — ${toName}` : _T.COMMON_FLIGHT;
            const dateLabel = moment(svc.begin).isValid() ? moment(svc.begin).format('L') : '';
            const label = dateLabel ? `${baseName} • ${dateLabel}` : baseName;
            const sortKey = moment(svc.begin).isValid() ? moment(svc.begin).valueOf() : 0;
            items.push({
                key: `flight-${svc.id}`,
                label,
                ownerServiceId: svc.id,
                segmentServiceId: svc.id,
                schemeId: schemeId || null,
                scheme: svc.scheme,
                flightId: svc.flightId,
                flightDate: svc.begin,
                flightClassGroupId: (_d = svc.flightClass) === null || _d === void 0 ? void 0 : _d.id,
                tourists: svc.tourists || [],
                totalPersons: getServicePersonCount(svc),
                legacyPlaceSource: 'busPlaceId',
                selectionTarget: 'flightPlaces',
                bookedPlaceIds: (_e = svc.bookedPlaceIds) !== null && _e !== void 0 ? _e : null,
                sortKey,
            });
        });
        const bookingBuses = booking.services.filter(s => s.type === 'BookingBusTransportationService');
        bookingBuses.forEach(svc => {
            var _a, _b, _c, _d;
            if (!svc.scheme)
                return;
            const fromName = ((_a = svc.placeFrom) === null || _a === void 0 ? void 0 : _a.name) || ((_b = svc.cityFrom) === null || _b === void 0 ? void 0 : _b.name);
            const toName = ((_c = svc.placeTo) === null || _c === void 0 ? void 0 : _c.name) || ((_d = svc.cityTo) === null || _d === void 0 ? void 0 : _d.name);
            const baseName = fromName && toName ? `${fromName} — ${toName}` : 'Автобус';
            const dateLabel = moment(svc.begin).isValid() ? moment(svc.begin).format('L') : '';
            const label = dateLabel ? `${baseName} • ${dateLabel}` : baseName;
            const sortKey = moment(svc.begin).isValid() ? moment(svc.begin).valueOf() : 0;
            items.push({
                key: `bus-${svc.id}`,
                label,
                ownerServiceId: svc.id,
                segmentServiceId: svc.id,
                scheme: svc.scheme,
                tourists: svc.tourists || [],
                totalPersons: getServicePersonCount(svc),
                selectionTarget: 'busPlace',
                sortKey,
            });
        });
        const tourServices = booking.services.filter(s => s.type === 'BookingTourService');
        tourServices.forEach(tourSvc => {
            const flights = (tourSvc.allTourServices || []).filter(ts => ts.type == 'flight');
            if (!flights.length)
                return;
            const sortedFlights = [...flights].sort((a, b) => {
                var _a, _b;
                const orderA = (_a = a.order) !== null && _a !== void 0 ? _a : 0;
                const orderB = (_b = b.order) !== null && _b !== void 0 ? _b : 0;
                if (orderA !== orderB)
                    return orderA - orderB;
                const dateA = a.beginDate ? moment(a.beginDate).valueOf() : 0;
                const dateB = b.beginDate ? moment(b.beginDate).valueOf() : 0;
                return dateA - dateB;
            });
            const withScheme = sortedFlights
                .map(f => ({ flight: f, schemeId: resolveTourFlightSchemeId(f) }))
                .filter(f => { var _a; return ((_a = f.schemeId) !== null && _a !== void 0 ? _a : 0) > 0 && !!f.flight.serviceId; });
            if (!withScheme.length)
                return;
            const useLegacy = withScheme.length <= 2;
            withScheme.forEach((entry, idx) => {
                var _a, _b, _c, _d, _e, _f;
                const flightInfo = (_b = (_a = entry.flight.calcFlights) === null || _a === void 0 ? void 0 : _a.find(f => { var _a; return ((_a = f.schemeId) !== null && _a !== void 0 ? _a : 0) > 0; })) !== null && _b !== void 0 ? _b : (_c = entry.flight.calcFlights) === null || _c === void 0 ? void 0 : _c[0];
                const fromName = (_d = entry.flight.cityFrom) === null || _d === void 0 ? void 0 : _d.name;
                const toName = (_e = entry.flight.cityTo) === null || _e === void 0 ? void 0 : _e.name;
                const baseName = fromName && toName ? `${fromName} — ${toName}` : `Перелет ${idx + 1}`;
                const dateLabel = (flightInfo === null || flightInfo === void 0 ? void 0 : flightInfo.dateDeparture) ? moment(flightInfo.dateDeparture).format('L') : '';
                const label = dateLabel ? `${baseName} • ${dateLabel}` : baseName;
                const sortKey = (flightInfo === null || flightInfo === void 0 ? void 0 : flightInfo.dateDeparture) ? moment(flightInfo.dateDeparture).valueOf() : (entry.flight.beginDate ? moment(entry.flight.beginDate).valueOf() : 0);
                items.push({
                    key: `tour-${tourSvc.id}-${entry.flight.serviceId}`,
                    label,
                    ownerServiceId: tourSvc.id,
                    segmentServiceId: entry.flight.serviceId,
                    schemeId: entry.schemeId,
                    flightId: flightInfo === null || flightInfo === void 0 ? void 0 : flightInfo.id,
                    flightDate: flightInfo === null || flightInfo === void 0 ? void 0 : flightInfo.dateDeparture,
                    flightClassGroupId: (_f = entry.flight.flightClass) === null || _f === void 0 ? void 0 : _f.id,
                    tourists: tourSvc.tourists || [],
                    totalPersons: getServicePersonCount(tourSvc),
                    legacyPlaceSource: useLegacy ? (idx === 0 ? 'busPlaceId' : 'busPlaceBackId') : undefined,
                    selectionTarget: 'flightPlaces',
                    sortKey,
                });
            });
        });
        return items.sort((a, b) => a.sortKey - b.sortKey);
    }, [booking.services]);
    const activeSegment = segments[selectedTab];
    const activeScheme = activeSegment ? segmentSchemes[activeSegment.key] : undefined;
    const activeScale = activeSegment ? ((_a = segmentScale[activeSegment.key]) !== null && _a !== void 0 ? _a : 1) : 1;
    const activeRotation = activeSegment ? ((_b = segmentRotation[activeSegment.key]) !== null && _b !== void 0 ? _b : 0) : 0;
    const isAircraftScheme = (activeScheme === null || activeScheme === void 0 ? void 0 : activeScheme.schemeType) === 'Aircraft';
    const activeBookingFlightService = useMemo(() => {
        if (!activeSegment)
            return undefined;
        return booking.services.find(s => s.type === 'BookingFlightService' && s.id === activeSegment.ownerServiceId);
    }, [activeSegment, booking.services]);
    const activePlaceSelectionService = useMemo(() => {
        if (!activeSegment)
            return undefined;
        return booking.services.find(s => s.id === activeSegment.ownerServiceId);
    }, [activeSegment, booking.services]);
    const activeSeatPriceService = useMemo(() => {
        if (!activeSegment)
            return undefined;
        return booking.services.find(s => s.id === activeSegment.ownerServiceId);
    }, [activeSegment, booking.services]);
    const activePlaceSelectionExtras = (activePlaceSelectionService === null || activePlaceSelectionService === void 0 ? void 0 : activePlaceSelectionService.placeSelectionExtras) || {};
    const getExtraMinimalGroupCost = (groupPrices, nonGroupPrices, adultCount, childAges) => {
        let groupPrice = _.minBy(groupPrices, e => e.costEntityWithPromo.total);
        let totalServices = [];
        let nonGroupPrice = 0;
        let adultPrice = _.minBy(nonGroupPrices.filter(e => e.ageTo >= 18), e => e.costEntityWithPromo.total);
        if (!adultPrice)
            return groupPrice ? [[groupPrice], groupPrice.costEntityWithPromo.total] : [[], undefined];
        totalServices.push(..._.range(0, adultCount).map(_ => adultPrice));
        nonGroupPrice += adultPrice.costEntityWithPromo.total * adultCount;
        for (let x of childAges) {
            let agedPrice = _.minBy(nonGroupPrices.filter(e => x >= e.ageFrom && x < e.ageTo), e => e.costEntityWithPromo.total);
            if (!agedPrice)
                return groupPrice ? [[groupPrice], groupPrice.costEntityWithPromo.total] : [[], undefined];
            totalServices.push(agedPrice);
            nonGroupPrice += agedPrice.costEntityWithPromo.total;
        }
        return groupPrice && groupPrice.costEntityWithPromo.total < nonGroupPrice ? [[groupPrice], groupPrice.costEntityWithPromo.total] : [totalServices, nonGroupPrice];
    };
    const placeSelectExtras = useMemo(() => {
        var _a, _b, _c;
        if (!activePlaceSelectionService)
            return undefined;
        const prices = ((_a = activePlaceSelectionService.placeSelectionExtraPrices) === null || _a === void 0 ? void 0 : _a.filter(e => e.typeId == 5 && e.code == 5)) || [];
        if (!prices.length)
            return undefined;
        const nonGroupPrices = prices.filter(e => !e.isGroupCost);
        const groupPrices = prices.filter(e => e.isGroupCost);
        const childAges = getServiceChildAges(activePlaceSelectionService);
        let [servicePrices, p] = getExtraMinimalGroupCost(groupPrices, nonGroupPrices, (_c = (_b = activePlaceSelectionService.accommodation) === null || _b === void 0 ? void 0 : _b.adults) !== null && _c !== void 0 ? _c : 0, childAges);
        if (p === undefined)
            return undefined;
        return {
            totalCost: p,
            servicePrices,
            servicePricesKeys: _.difference(servicePrices.map(e => getExtraKey(e))),
        };
    }, [activePlaceSelectionService]);
    useEffect(() => {
        if (selectedTab >= segments.length) {
            setSelectedTab(0);
        }
    }, [segments.length, selectedTab]);
    const sizeMultiplier = useMemo(() => {
        if (!activeScheme)
            return 1;
        if (activeScheme.schemeType === 'Aircraft')
            return 1;
        return Math.max(16 / activeScheme.data.bus.seatHeight, 16 / activeScheme.data.bus.seatWidth, 1000 / activeScheme.data.bus.width);
    }, [activeScheme]);
    const stageStyle = useMemo(() => ({
        width: isAircraftScheme ? size.width : '100%',
        maxWidth: isAircraftScheme ? 'none' : '100%',
        overflow: 'auto',
        maxHeight: 'calc(100vh - 160px)',
    }), [isAircraftScheme, size.width]);
    const calcSize = useCallback((currentScheme, multiplier = 1) => {
        var _a, _b, _c, _d;
        const containerWidth = (_b = (_a = bookerContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0;
        const containerHeight = (_d = (_c = bookerContainerRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0;
        const schemeWidth = (currentScheme ? ((currentScheme.data.bus.width * multiplier) + padding * 4) : 800);
        const schemeHeight = (currentScheme ? (((currentScheme.data.bus.height + currentScheme.data.bus.seatHeight) * currentScheme.data.bus.layers * multiplier) + padding * 8) : 450);
        return {
            width: containerWidth > 0 ? containerWidth : schemeWidth,
            height: containerHeight > 0 ? containerHeight : schemeHeight,
        };
    }, []);
    const resize = useCallback(throttle(() => {
        const newSize = calcSize(activeScheme, sizeMultiplier);
        if (newSize.width !== size.width || newSize.height !== size.height) {
            requestAnimationFrame(() => setSize(newSize));
        }
    }, 100), [activeScheme, sizeMultiplier, size.width, size.height, calcSize]);
    useLayoutEffect(() => {
        if (!bookerContainerRef.current)
            return;
        if (typeof ResizeObserver === 'undefined') {
            resize();
            return;
        }
        const observer = new ResizeObserver(() => resize());
        observer.observe(bookerContainerRef.current);
        return () => observer.disconnect();
    }, [resize]);
    useEffect(() => {
        window.addEventListener('resize', resize);
        resize();
        return () => {
            window.removeEventListener('resize', resize);
        };
    }, [resize]);
    useEffect(() => {
        if (dialogOpen) {
            resize();
        }
    }, [dialogOpen, resize]);
    useEffect(() => {
        if (selectedTouristIndex === undefined)
            return;
        if (!activeSegment)
            return;
        if (selectedTouristIndex >= activeSegment.tourists.length) {
            setSelectedTouristIndex(undefined);
        }
    }, [activeSegment, selectedTouristIndex]);
    const loadSegmentConfiguration = useCallback((segment) => __awaiter(this, void 0, void 0, function* () {
        if (!segment)
            return;
        if (loadingSegmentKeysRef.current.has(segment.key))
            return;
        loadingSegmentKeysRef.current.add(segment.key);
        try {
            if (segment.scheme) {
                setSegmentSchemes(prev => (Object.assign(Object.assign({}, prev), { [segment.key]: normalizeScheme(segment.scheme) })));
                setSegmentUnavailable(prev => { var _a; return (Object.assign(Object.assign({}, prev), { [segment.key]: (_a = segment.bookedPlaceIds) !== null && _a !== void 0 ? _a : [] })); });
                return;
            }
            if (!segment.schemeId)
                return;
            const params = { schemeId: segment.schemeId };
            if (segment.flightId && segment.flightDate) {
                params.flightId = segment.flightId;
                params.flightDate = moment(segment.flightDate).format('YYYY-MM-DD');
            }
            const { response } = yield api('get', 'FlightStatic/SchemeConfiguration', params);
            if (response === null || response === void 0 ? void 0 : response.scheme) {
                setSegmentSchemes(prev => (Object.assign(Object.assign({}, prev), { [segment.key]: normalizeScheme(response.scheme) })));
                setSegmentUnavailable(prev => { var _a; return (Object.assign(Object.assign({}, prev), { [segment.key]: (_a = response.bookedPlaceIds) !== null && _a !== void 0 ? _a : [] })); });
            }
        }
        finally {
            loadingSegmentKeysRef.current.delete(segment.key);
        }
    }), []);
    useEffect(() => {
        if (!dialogOpen)
            return;
        segments.forEach(segment => {
            if (!segmentSchemes[segment.key])
                loadSegmentConfiguration(segment);
        });
    }, [dialogOpen, segments, segmentSchemes, loadSegmentConfiguration]);
    const normalizeSelection = useCallback((selected, total) => {
        const normalized = selected.map(s => s !== null && s !== void 0 ? s : undefined);
        if (normalized.length >= total)
            return normalized;
        return [
            ...normalized,
            ...Array.from({ length: total - normalized.length }).map(() => undefined),
        ];
    }, []);
    const openDialog = useCallback((targetServiceId) => {
        if (!segments.length)
            return;
        const selections = {};
        segments.forEach(segment => {
            const values = segment.tourists.map(t => {
                var _a, _b;
                const existing = (_b = (_a = t.flightPlaces) === null || _a === void 0 ? void 0 : _a.find(p => p.serviceId === segment.segmentServiceId)) === null || _b === void 0 ? void 0 : _b.placeId;
                if (existing && !isPrecheckFlightPlaceId(existing))
                    return existing;
                if (segment.legacyPlaceSource === 'busPlaceBackId')
                    return t.busPlaceBackId || undefined;
                if (segment.legacyPlaceSource === 'busPlaceId')
                    return t.busPlaceId || undefined;
                return undefined;
            });
            selections[segment.key] = normalizeSelection(values, segment.totalPersons);
        });
        const targetIndex = targetServiceId ? segments.findIndex(segment => segment.ownerServiceId === targetServiceId || segment.segmentServiceId === targetServiceId) : -1;
        const nextIndex = targetIndex >= 0 ? targetIndex : 0;
        setSegmentSelections(selections);
        setSelectedTouristIndex(undefined);
        setSelectedTab(nextIndex);
        setDialogOpen(true);
    }, [normalizeSelection, segments]);
    useEffect(() => {
        const handler = (e) => {
            var _a;
            const targetServiceId = (_a = e === null || e === void 0 ? void 0 : e.detail) === null || _a === void 0 ? void 0 : _a.serviceId;
            if (targetServiceId && !segments.some(segment => segment.ownerServiceId === targetServiceId || segment.segmentServiceId === targetServiceId))
                return;
            openDialog(targetServiceId);
        };
        document.addEventListener('flightSchemeModalRequested', handler);
        return () => document.removeEventListener('flightSchemeModalRequested', handler);
    }, [openDialog, segments]);
    const activeSelections = activeSegment ? (segmentSelections[activeSegment.key] || []) : [];
    const activeUnavailable = activeSegment ? (segmentUnavailable[activeSegment.key] || []) : [];
    const activeTotalPersons = (_c = activeSegment === null || activeSegment === void 0 ? void 0 : activeSegment.totalPersons) !== null && _c !== void 0 ? _c : 0;
    const activeFlightClassId = activeSegment === null || activeSegment === void 0 ? void 0 : activeSegment.flightClassGroupId;
    const legendSeatBackSide = useMemo(() => {
        if (!activeScheme)
            return 'left';
        return activeScheme.data.bus.height > activeScheme.data.bus.width ? 'bottom' : 'left';
    }, [activeScheme]);
    const legendSeatSize = useMemo(() => {
        if (!activeScheme)
            return 28;
        const seatsForTariff = activeScheme.data.seats.filter(seat => seatMatchesFlightClass(seat, activeFlightClassId));
        const sourceSeats = seatsForTariff.length ? seatsForTariff : activeScheme.data.seats;
        const fallbackWidth = activeScheme.data.bus.seatWidth * sizeMultiplier;
        const fallbackHeight = activeScheme.data.bus.seatHeight * sizeMultiplier;
        const minSeatSize = sourceSeats.length
            ? Math.min(...sourceSeats.map(seat => {
                var _a, _b;
                return Math.min(((_a = seat.width) !== null && _a !== void 0 ? _a : activeScheme.data.bus.seatWidth) * sizeMultiplier, ((_b = seat.height) !== null && _b !== void 0 ? _b : activeScheme.data.bus.seatHeight) * sizeMultiplier);
            }))
            : Math.min(fallbackWidth, fallbackHeight);
        return Math.max(28, Math.round(minSeatSize));
    }, [activeFlightClassId, activeScheme, sizeMultiplier]);
    const legendSeatCorner = useMemo(() => Math.min(10, Math.round(legendSeatSize / 4)), [legendSeatSize]);
    const legendSeatBar = useMemo(() => Math.min(8, Math.round(legendSeatSize / 3)), [legendSeatSize]);
    const onSelectSeat = (place) => {
        if (!activeSegment)
            return;
        const selected = activeSelections;
        if (selectedTouristIndex !== undefined && selected.length > selectedTouristIndex) {
            const next = [
                ...selected.slice(0, selectedTouristIndex),
                selected[selectedTouristIndex] != place.id ? place.id : undefined,
                ...selected.slice(selectedTouristIndex + 1),
            ];
            setSegmentSelections(prev => (Object.assign(Object.assign({}, prev), { [activeSegment.key]: next })));
            return;
        }
        const oldIndex = selected.indexOf(place.id);
        if (oldIndex >= 0) {
            const next = [...selected.slice(0, oldIndex), undefined, ...selected.slice(oldIndex + 1)];
            setSegmentSelections(prev => (Object.assign(Object.assign({}, prev), { [activeSegment.key]: next })));
            return;
        }
        const emptyIndex = selected.findIndex(s => !s);
        if (emptyIndex < 0)
            return;
        const next = [...selected.slice(0, emptyIndex), place.id, ...selected.slice(emptyIndex + 1)];
        setSegmentSelections(prev => (Object.assign(Object.assign({}, prev), { [activeSegment.key]: next })));
    };
    const updateActiveScale = useCallback((nextScale) => {
        if (!activeSegment)
            return;
        setSegmentScale(prev => (Object.assign(Object.assign({}, prev), { [activeSegment.key]: nextScale })));
    }, [activeSegment]);
    const updateActiveRotation = useCallback((nextRotation) => {
        if (!activeSegment)
            return;
        setSegmentRotation(prev => (Object.assign(Object.assign({}, prev), { [activeSegment.key]: nextRotation })));
    }, [activeSegment]);
    const isSegmentComplete = useCallback((segment) => {
        if (!segment)
            return false;
        const selected = segmentSelections[segment.key] || [];
        if (selected.length < segment.totalPersons)
            return false;
        return !selected.some(s => !s);
    }, [segmentSelections]);
    const resetSelectionState = useCallback(() => {
        setDialogOpen(false);
        setSegmentSelections({});
        setSelectedTouristIndex(undefined);
        setSelectedTab(0);
    }, []);
    const collectSelectionUpdates = useCallback(() => {
        const allUpdates = [];
        const grouped = segments.reduce((acc, segment) => {
            acc[segment.ownerServiceId] = acc[segment.ownerServiceId] || [];
            acc[segment.ownerServiceId].push(segment);
            return acc;
        }, {});
        Object.entries(grouped).forEach(([serviceId, serviceSegments]) => {
            var _a;
            const segmentIds = serviceSegments.map(s => s.segmentServiceId);
            const tourists = ((_a = serviceSegments[0]) === null || _a === void 0 ? void 0 : _a.tourists) || [];
            const busSegments = serviceSegments.filter(segment => segment.selectionTarget === 'busPlace' || segment.selectionTarget === 'busPlaceBack');
            if (busSegments.length > 0) {
                const updates = tourists.map((t, ti) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                    const touristPatch = {};
                    busSegments.forEach(segment => {
                        var _a, _b, _c, _d;
                        const selected = (segmentSelections[segment.key] || [])[ti];
                        const scheme = segmentSchemes[segment.key];
                        const seat = selected ? scheme === null || scheme === void 0 ? void 0 : scheme.data.seats.find(s => s.id == selected) : undefined;
                        if (segment.selectionTarget === 'busPlaceBack') {
                            touristPatch.busPlaceBackId = selected !== null && selected !== void 0 ? selected : null;
                            touristPatch.busPlaceBackName = selected ? ((_a = seat === null || seat === void 0 ? void 0 : seat.name) !== null && _a !== void 0 ? _a : t.busPlaceBackName) : null;
                            touristPatch.busPlaceBackBookableId = selected ? ((_b = seat === null || seat === void 0 ? void 0 : seat.bookableId) !== null && _b !== void 0 ? _b : t.busPlaceBackBookableId) : null;
                        }
                        else {
                            touristPatch.busPlaceId = selected !== null && selected !== void 0 ? selected : null;
                            touristPatch.busPlaceName = selected ? ((_c = seat === null || seat === void 0 ? void 0 : seat.name) !== null && _c !== void 0 ? _c : t.busPlaceName) : null;
                            touristPatch.busPlaceBookableId = selected ? ((_d = seat === null || seat === void 0 ? void 0 : seat.bookableId) !== null && _d !== void 0 ? _d : t.busPlaceBookableId) : null;
                        }
                    });
                    const changed = (((_a = touristPatch.busPlaceId) !== null && _a !== void 0 ? _a : null) !== ((_b = t.busPlaceId) !== null && _b !== void 0 ? _b : null)
                        || ((_c = touristPatch.busPlaceName) !== null && _c !== void 0 ? _c : null) !== ((_d = t.busPlaceName) !== null && _d !== void 0 ? _d : null)
                        || ((_e = touristPatch.busPlaceBookableId) !== null && _e !== void 0 ? _e : null) !== ((_f = t.busPlaceBookableId) !== null && _f !== void 0 ? _f : null)
                        || ((_g = touristPatch.busPlaceBackId) !== null && _g !== void 0 ? _g : null) !== ((_h = t.busPlaceBackId) !== null && _h !== void 0 ? _h : null)
                        || ((_j = touristPatch.busPlaceBackName) !== null && _j !== void 0 ? _j : null) !== ((_k = t.busPlaceBackName) !== null && _k !== void 0 ? _k : null)
                        || ((_l = touristPatch.busPlaceBackBookableId) !== null && _l !== void 0 ? _l : null) !== ((_m = t.busPlaceBackBookableId) !== null && _m !== void 0 ? _m : null));
                    if (!changed)
                        return null;
                    return {
                        personIdx: ti,
                        tourist: touristPatch,
                    };
                }).filter(Boolean);
                if (updates.length > 0) {
                    allUpdates.push({
                        serviceId: Number(serviceId),
                        tourists: updates,
                    });
                }
                return;
            }
            const flightPlaceSegments = serviceSegments.filter(segment => segment.selectionTarget === 'flightPlaces');
            if (!flightPlaceSegments.length)
                return;
            const flightSegmentIds = flightPlaceSegments.map(s => s.segmentServiceId);
            const normalizePlaces = (places) => {
                return (places || [])
                    .filter(p => flightSegmentIds.includes(p.serviceId))
                    .map(p => {
                    var _a, _b, _c;
                    return ({
                        serviceId: p.serviceId,
                        placeId: (_a = p.placeId) !== null && _a !== void 0 ? _a : null,
                        placeName: (_b = p.placeName) !== null && _b !== void 0 ? _b : null,
                        bookableId: (_c = p.bookableId) !== null && _c !== void 0 ? _c : null,
                    });
                })
                    .sort((a, b) => a.serviceId - b.serviceId);
            };
            const samePlaces = (a, b) => {
                var _a, _b, _c, _d, _e, _f;
                if (a.length !== b.length)
                    return false;
                for (let i = 0; i < a.length; i++) {
                    const left = a[i];
                    const right = b[i];
                    if (left.serviceId !== right.serviceId)
                        return false;
                    if (((_a = left.placeId) !== null && _a !== void 0 ? _a : null) !== ((_b = right.placeId) !== null && _b !== void 0 ? _b : null))
                        return false;
                    if (((_c = left.bookableId) !== null && _c !== void 0 ? _c : null) !== ((_d = right.bookableId) !== null && _d !== void 0 ? _d : null))
                        return false;
                    if (((_e = left.placeName) !== null && _e !== void 0 ? _e : null) !== ((_f = right.placeName) !== null && _f !== void 0 ? _f : null))
                        return false;
                }
                return true;
            };
            const updates = tourists.map((t, ti) => {
                let nextPlaces = (t.flightPlaces || []).filter(p => !flightSegmentIds.includes(p.serviceId));
                flightPlaceSegments.forEach(segment => {
                    var _a, _b;
                    const selected = (segmentSelections[segment.key] || [])[ti];
                    if (!selected)
                        return;
                    const scheme = segmentSchemes[segment.key];
                    const seat = scheme === null || scheme === void 0 ? void 0 : scheme.data.seats.find(s => s.id == selected);
                    const prev = (t.flightPlaces || []).find(p => p.serviceId === segment.segmentServiceId);
                    nextPlaces = [
                        ...nextPlaces,
                        {
                            serviceId: segment.segmentServiceId,
                            placeId: selected,
                            placeName: (_a = seat === null || seat === void 0 ? void 0 : seat.name) !== null && _a !== void 0 ? _a : prev === null || prev === void 0 ? void 0 : prev.placeName,
                            bookableId: (_b = seat === null || seat === void 0 ? void 0 : seat.bookableId) !== null && _b !== void 0 ? _b : prev === null || prev === void 0 ? void 0 : prev.bookableId,
                        }
                    ];
                });
                const currentSegmentPlaces = normalizePlaces(t.flightPlaces);
                const nextSegmentPlaces = normalizePlaces(nextPlaces);
                if (samePlaces(currentSegmentPlaces, nextSegmentPlaces))
                    return null;
                return {
                    personIdx: ti,
                    tourist: {
                        flightPlaces: nextPlaces,
                    }
                };
            }).filter(Boolean);
            if (updates.length > 0) {
                allUpdates.push({
                    serviceId: Number(serviceId),
                    tourists: updates,
                });
            }
        });
        return allUpdates;
    }, [segmentSchemes, segmentSelections, segments]);
    const placesValid = useMemo(() => {
        if (!segments.length)
            return true;
        return segments.every(segment => {
            const selected = segmentSelections[segment.key] || [];
            if (selected.length < segment.totalPersons)
                return false;
            if (selected.some(s => !s))
                return false;
            return true;
        });
    }, [segmentSelections, segments]);
    const onContinue = useCallback(() => {
        if (!activeSegment)
            return;
        if (!isSegmentComplete(activeSegment))
            return;
        const isLastTab = selectedTab >= segments.length - 1;
        if (!isLastTab) {
            setSelectedTab(prev => Math.min(prev + 1, segments.length - 1));
            setSelectedTouristIndex(undefined);
            return;
        }
        if (!placesValid)
            return;
        const updates = collectSelectionUpdates();
        resetSelectionState();
        setTimeout(() => onMakeBooking(updates), 300);
    }, [activeSegment, collectSelectionUpdates, isSegmentComplete, onMakeBooking, placesValid, resetSelectionState, segments.length, selectedTab]);
    const handleSkipPlaceSelection = useCallback(() => {
        resetSelectionState();
        setTimeout(() => onSkipPlaceSelection ? onSkipPlaceSelection() : onMakeBooking(undefined, { skipPlaceSelectionPrompt: true, clearPlaceSelection: true }), 300);
    }, [onMakeBooking, onSkipPlaceSelection, resetSelectionState]);
    if (!segments.length)
        return null;
    return (React.createElement(Dialog, { open: dialogOpen, onClose: () => resetSelectionState(), maxWidth: 'lg', fullScreen: false, TransitionProps: { onEntered: () => resize() } },
        React.createElement(DialogTitle, { disableTypography: true, style: { paddingRight: '56px', position: 'relative' } },
            React.createElement(Typography, { variant: "h6" }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u0435\u0441\u0442\u0430 \u0434\u043B\u044F \u043F\u0430\u0441\u0441\u0430\u0436\u0438\u0440\u043E\u0432"),
            React.createElement(IconButton, { size: "small", "aria-label": _T.COMMON_CLOSE || 'Закрыть', onClick: () => resetSelectionState(), style: { position: 'absolute', right: '16px', top: '16px' } },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { style: { overflow: 'hidden', height: 'calc(100vh - 160px)', minWidth: '800px' }, classes: { root: 'p-0' } },
            segments.length > 1 ? (React.createElement(Box, { px: 2, pt: 1, pb: 0 },
                React.createElement(Tabs, { value: selectedTab, onChange: (_, value) => setSelectedTab(value), variant: "scrollable", scrollButtons: "auto" }, segments.map(segment => (React.createElement(Tab, { key: segment.key, label: segment.label })))))) : null,
            activeSegment && activeScheme ? (React.createElement("div", { style: { display: 'flex', height: '100%' } },
                React.createElement("div", { style: { width: '250px', minWidth: '250px', padding: `${padding}px ${padding}px 0 ${padding}px` } },
                    React.createElement(BookerViewControls, { scale: activeScale, rotation: activeRotation, onScaleChange: updateActiveScale, onRotationChange: updateActiveRotation }),
                    React.createElement(Select, { formControlProps: {
                            style: { width: '100%' }
                        }, labelClassName: 'MuiInputLabel-shrink', className: 'my-2', variant: 'filled', label: _T.COMMON_TOURIST, value: selectedTouristIndex === undefined ? -1 : selectedTouristIndex, onChange: (e) => {
                            const v = Number.parseInt(e.target.value);
                            setSelectedTouristIndex(v == -1 ? undefined : v);
                        }, inputProps: {
                            name: 'touristIndex',
                            id: 'touristIndex'
                        } }, [{ name: _T.COMMON_ALL, index: -1 }, ...(activeSegment.tourists || []).map((t, i) => {
                            var _a, _b, _c;
                            return ({
                                name: `${(_a = t.surname) !== null && _a !== void 0 ? _a : ''} ${(_b = t.name) !== null && _b !== void 0 ? _b : ''} ${(_c = t.middleName) !== null && _c !== void 0 ? _c : ''}`.trim() || `${_T.COMMON_ADULT} ${i + 1}`,
                                index: i
                            });
                        })].map(o => (React.createElement("option", { key: o.index, value: o.index }, o.name)))),
                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '6px', pointerEvents: 'none', marginTop: '8px' } }, [
                        { key: 'available', label: 'свободно', fill: 'transparent' },
                        { key: 'booked', label: 'забронировано', fill: theme.palette.grey['600'] },
                        { key: 'selected', label: 'выбрано', fill: theme.palette.success.main },
                    ].map(item => (React.createElement("div", { key: item.key, style: { display: 'flex', alignItems: 'center', gap: '8px' } },
                        React.createElement("div", { style: {
                                width: legendSeatSize,
                                height: legendSeatSize,
                                borderRadius: legendSeatCorner,
                                border: `1px solid ${theme.palette.text.primary}`,
                                backgroundColor: item.fill,
                                position: 'relative',
                                boxSizing: 'border-box',
                            } },
                            React.createElement("div", { style: {
                                    position: 'absolute',
                                    left: legendSeatBackSide === 'bottom' ? 5 : 2,
                                    top: legendSeatBackSide === 'bottom'
                                        ? Math.max(0, legendSeatSize - legendSeatBar - 5)
                                        : 5,
                                    width: legendSeatBackSide === 'bottom' ? Math.max(2, legendSeatSize - 10) : legendSeatBar,
                                    height: legendSeatBackSide === 'bottom' ? legendSeatBar : Math.max(2, legendSeatSize - 10),
                                    borderRadius: legendSeatCorner,
                                    backgroundColor: theme.palette.grey['700'],
                                } })),
                        React.createElement(Typography, { variant: "body2", style: { color: theme.palette.text.primary } },
                            "- ",
                            item.label)))))),
                React.createElement("div", { ref: bookerContainerRef, style: { flex: 1, minWidth: '800px' } },
                    React.createElement(BookerBase, { id: `flight-booker-stage-${activeSegment.key}`, stageStyle: stageStyle, data: activeScheme.data, showLegend: false, sizeMultiplier: sizeMultiplier, size: size, showControls: false, scale: activeScale, onScaleChange: updateActiveScale, rotation: activeRotation, onRotationChange: updateActiveRotation, allowChoiceFunc: p => {
                            if (activeFlightClassId && !seatMatchesFlightClass(p, activeFlightClassId) && !activeSelections.includes(p.id))
                                return false;
                            if (selectedTouristIndex !== undefined) {
                                const unavailable = [
                                    ...activeUnavailable,
                                    ...activeSelections.filter((t, i) => i != selectedTouristIndex && !!t),
                                ];
                                return unavailable.findIndex(ux => ux === p.id && ux != activeSelections[selectedTouristIndex]) < 0;
                            }
                            if (activeSelections.length == activeTotalPersons && !activeSelections.filter(s => !s).length && activeSelections.findIndex(s => s == p.id) < 0)
                                return false;
                            return activeUnavailable.findIndex(ux => ux === p.id && !activeSelections.includes(ux)) < 0;
                        }, availableFunc: p => {
                            if (activeFlightClassId && !seatMatchesFlightClass(p, activeFlightClassId) && !activeSelections.includes(p.id))
                                return false;
                            if (selectedTouristIndex !== undefined) {
                                const unavailable = [
                                    ...activeUnavailable,
                                    ...activeSelections.filter((t, i) => i != selectedTouristIndex && !!t),
                                ];
                                return unavailable.findIndex(ux => ux === p.id && ux != activeSelections[selectedTouristIndex]) < 0;
                            }
                            return activeUnavailable.findIndex(ux => ux === p.id && !activeSelections.includes(ux)) < 0;
                        }, selectedFunc: p => {
                            if (selectedTouristIndex !== undefined)
                                return activeSelections[selectedTouristIndex] == p.id;
                            return activeSelections.includes(p.id);
                        }, renderSeatPopupContent: renderSeatPricePopup(activeSeatPriceService, activeSegment.segmentServiceId, booking.currency.name), onSelect: (p) => onSelectSeat(p), onDrag: activeScheme.schemeType === 'Aircraft' ? undefined : (pos => {
                            const panel = document.querySelector(`#flight-booker-stage-${activeSegment.key} .konvajs-content`);
                            const parent = panel === null || panel === void 0 ? void 0 : panel.parentElement;
                            if (parent)
                                parent.scrollBy({ top: -pos.y, left: -pos.x, behavior: 'auto' });
                            return { x: padding * 2, y: 0 };
                        }) })))) : (React.createElement(AsyncSpinner, null))),
        React.createElement(DialogActions, { className: "p-0", style: { display: 'block' } },
            placeSelectExtras && activePlaceSelectionService ? (React.createElement(FormControl, { component: "fieldset", fullWidth: true, style: { padding: '0 24px 8px' } },
                React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: !placeSelectExtras.servicePricesKeys.find(e => { var _a; return ((_a = activePlaceSelectionExtras[e]) === null || _a === void 0 ? void 0 : _a.length) != activeTotalPersons; }), onChange: (e, v) => {
                            let indexes = _.range(0, activeTotalPersons);
                            let newValues = Object.assign({}, activePlaceSelectionExtras);
                            for (let key of placeSelectExtras.servicePricesKeys)
                                newValues[key] = v ? [...indexes] : undefined;
                            onServiceChange(activePlaceSelectionService.id, { placeSelectionExtras: newValues });
                        } }), label: `Добавить услугу выбора места (${formatMoney(placeSelectExtras.totalCost, { currency: booking.currency.name, localeAware: true })} ${booking.currency.name})` }),
                React.createElement(FormHelperText, { style: { fontSize: '0.875em' } }, "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0432\u044B\u0431\u043E\u0440 \u043C\u0435\u0441\u0442\u0430 \u043D\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u043E\u043C \u0431\u0435\u0437 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F. \u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0437\u0430\u043F\u0440\u0435\u0442\u0438\u0442 \u043F\u0435\u0440\u0435\u0441\u0430\u0434\u043A\u0443 \u0431\u0435\u0437 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u044F \u0441 \u0412\u0430\u043C\u0438."))) : null,
            React.createElement(Box, { className: "payment-buttons", style: { padding: '0 24px' } },
                React.createElement(Box, { className: "payment-button payment-button-cancel" },
                    React.createElement(Button, { variant: "outlined", color: "default", onClick: () => resetSelectionState() }, _T.COMMON_CANCEL_2)),
                allowSkipPlaceSelection ? (React.createElement(Box, { className: "payment-button payment-button-cancel" },
                    React.createElement(Button, { variant: "outlined", color: "default", onClick: handleSkipPlaceSelection }, "\u041E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u0432\u044B\u0431\u043E\u0440\u0430 \u043C\u0435\u0441\u0442"))) : null,
                selectedTab > 0 ? (React.createElement(Box, { className: "payment-button payment-button-cancel" },
                    React.createElement(Button, { variant: "outlined", color: "default", onClick: () => {
                            setSelectedTab(prev => Math.max(prev - 1, 0));
                            setSelectedTouristIndex(undefined);
                        } }, "\u041D\u0430\u0437\u0430\u0434"))) : null,
                React.createElement(Box, { className: "payment-button payment-button-confirm" }, (selectedTab < segments.length - 1 ? isSegmentComplete(activeSegment) : placesValid)
                    ? React.createElement(Button, { variant: "contained", color: "primary", onClick: onContinue }, selectedTab < segments.length - 1 ? `${_T.COMMON_CONTINUE} »` : (confirmButtonText || `${_T.COMMON_CONTINUE} »`))
                    : React.createElement(Tooltip, { title: React.createElement(Typography, { variant: 'body2' }, selectedTab < segments.length - 1
                            ? 'Чтобы продолжить, выберите места для всех пассажиров на текущем сегменте'
                            : 'Чтобы продолжить, выберите места для всех пассажиров'), placement: "bottom" },
                        React.createElement(Button, { variant: "contained", color: "primary", disabled: true, style: { pointerEvents: 'auto' }, onClick: onContinue }, selectedTab < segments.length - 1 ? `${_T.COMMON_CONTINUE} »` : (confirmButtonText || `${_T.COMMON_CONTINUE} »`))))))));
}
